import { authenReducer } from "../reducer/AuthenReducer";

export const reducer = authenReducer;
